import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { handleLogout } from '../controllers/authController';
import LoginModal    from './LoginModal';
import RegisterModal from './RegisterModal';

const Navbar = ({ scrolled = false }) => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { user, logout } = useAuth();
  const [menuOpen,     setMenuOpen]     = useState(false);
  const [showLogin,    setShowLogin]    = useState(false);
  const [showRegister, setShowRegister] = useState(false);

  const isHome      = location.pathname === '/';
  const transparent = isHome && !scrolled;
  const textColor   = transparent ? 'text-white'      : 'text-gray-700';
  const logoColor   = transparent ? 'text-white'      : 'text-gray-900';
  const accentColor = transparent ? 'text-yellow-400' : 'text-blue-700';
  const borderColor = transparent ? 'border-white/30' : 'border-gray-200';
  const navBg       = transparent ? 'bg-transparent'  : 'bg-white shadow-sm';

  const linkClass = `text-sm font-medium transition hover:opacity-70 ${textColor}`;

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBg}`} style={{ height: 72 }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-full flex items-center">

          {/* Logo */}
          <Link to="/" className={`text-xl font-bold mr-10 ${logoColor}`}>
            Oto<span className={accentColor}>ParçamıBul</span>
          </Link>

          {/* Center links */}
          <div className="hidden md:flex flex-1 items-center justify-center gap-8">
            <Link to="/request"   className={linkClass}>Parça Talebi</Link>
            <Link to="/stock"     className={linkClass}>Parça Stoku</Link>
            <Link to="/kategoriler" className={linkClass}>Kategoriler</Link>
            <Link to="/suppliers" className={linkClass}>Tedarikçiler</Link>
            <Link to="/how-it-works" className={linkClass}>Nasıl Çalışır?</Link>
          </div>

          {/* Right — auth */}
          <div className="hidden md:flex items-center gap-3 ml-10">
            {user ? (
              <>
                <Link to={
                  user.role === 'admin'    ? '/dashboard/admin' :
                  user.role === 'supplier' ? '/dashboard/supplier' :
                  '/dashboard/customer'
                } className={`text-sm font-medium ${textColor}`}>
                  Panel
                </Link>
                <button onClick={() => handleLogout(logout, navigate)}
                  className="bg-blue-700 hover:bg-blue-800 text-white text-sm font-semibold px-5 py-2 rounded-lg transition">
                  Çıkış
                </button>
              </>
            ) : (
              <>
                <button onClick={() => setShowLogin(true)}
                  className={`text-sm font-medium border px-5 py-2 rounded-lg transition ${textColor} ${borderColor} hover:bg-white/10`}>
                  Giriş Yap
                </button>
                <button onClick={() => setShowRegister(true)}
                  className="bg-blue-700 hover:bg-blue-800 text-white text-sm font-semibold px-5 py-2 rounded-lg transition">
                  Kayıt Ol
                </button>
              </>
            )}
          </div>

          {/* Mobile hamburger */}
          <button className={`md:hidden ml-auto text-2xl ${textColor}`}
            onClick={() => setMenuOpen(o => !o)} aria-label="Menü">
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 space-y-2 shadow-lg">
            <Link to="/request"   onClick={() => setMenuOpen(false)} className="block text-sm text-gray-700 py-2 hover:text-blue-700">Parça Talebi</Link>
            <Link to="/stock"     onClick={() => setMenuOpen(false)} className="block text-sm text-gray-700 py-2 hover:text-blue-700">Parça Stoku</Link>
            <Link to="/kategoriler" onClick={() => setMenuOpen(false)} className="block text-sm text-gray-700 py-2 hover:text-blue-700">Kategoriler</Link>
            <Link to="/suppliers" onClick={() => setMenuOpen(false)} className="block text-sm text-gray-700 py-2 hover:text-blue-700">Tedarikçiler</Link>
            <Link to="/how-it-works" onClick={() => setMenuOpen(false)} className="block text-sm text-gray-700 py-2 hover:text-blue-700">Nasıl Çalışır?</Link>
            <div className="pt-2 border-t border-gray-100 flex gap-3">
              <button onClick={() => { setMenuOpen(false); setShowLogin(true); }}
                className="flex-1 text-center text-sm text-gray-700 border border-gray-200 py-2 rounded-lg">
                Giriş Yap
              </button>
              <button onClick={() => { setMenuOpen(false); setShowRegister(true); }}
                className="flex-1 text-center text-sm bg-blue-700 text-white py-2 rounded-lg">
                Kayıt Ol
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Modals */}
      {showLogin && (
        <LoginModal
          onClose={() => setShowLogin(false)}
          onSwitchToRegister={() => { setShowLogin(false); setShowRegister(true); }}
        />
      )}
      {showRegister && (
        <RegisterModal
          onClose={() => setShowRegister(false)}
          onSwitchToLogin={() => { setShowRegister(false); setShowLogin(true); }}
        />
      )}
    </>
  );
};

export default Navbar;